import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const brands = [
    { name: 'カルティエ', path: '/brands/cartier' },
    { name: 'ロレックス', path: '/brands/rolex' },
    { name: 'ショパール', path: '/brands/chopard' },
    { name: 'IWC', path: '/brands/iwc' },
    { name: 'チューダー', path: '/brands/tudor' },
    { name: 'テンデンス', path: '/brands/tendence' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/70a4703660d18bee8c4b43bbf221e0fa/1530ddfdb78e284e8b3367331d0873c0.png"
              alt="ChronoCharm"
              className="h-24 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/#about" className="text-gray-700 hover:text-amber-600 transition-colors font-medium cursor-pointer">
              ホーム
            </a>
            
            {/* Services Dropdown */}
            <div 
              className="relative"
              onMouseEnter={() => setServicesDropdownOpen(true)}
              onMouseLeave={() => setServicesDropdownOpen(false)}
            >
              <button
                onClick={() => scrollToSection('services')}
                className="text-sm font-medium transition-colors whitespace-nowrap cursor-pointer text-gray-900 hover:text-amber-600"
              >
                高級腕時計
              </button>
              
              {/* Dropdown Menu */}
              {servicesDropdownOpen && (
                <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-48 bg-amber-600 shadow-lg rounded-md overflow-hidden">
                  {brands.map((brand, index) => (
                    <a
                      key={index}
                      href={brand.path}
                      className="block px-6 py-3 text-white text-sm font-medium hover:bg-amber-700 transition-colors cursor-pointer"
                    >
                      {brand.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a href="/tokushoho" className="text-gray-700 hover:text-amber-600 transition-colors font-medium cursor-pointer">
              特定商取引に基づく表記
            </a>
            <a href="/guide" className="text-gray-700 hover:text-amber-600 transition-colors font-medium cursor-pointer">
              高級腕時計ガイド
            </a>
            <a href="/privacy" className="text-gray-700 hover:text-amber-600 transition-colors font-medium cursor-pointer">
              プライバシーポリシー
            </a>
            <a href="/#contact" className="text-gray-700 hover:text-amber-600 transition-colors font-medium cursor-pointer">
              お問い合わせ
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden p-2 rounded-md cursor-pointer ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left text-gray-900 hover:text-amber-600 font-medium cursor-pointer"
            >
              ホーム
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-gray-900 hover:text-amber-600 font-medium cursor-pointer"
            >
              私たちについて
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="block w-full text-left text-gray-900 hover:text-amber-600 font-medium cursor-pointer"
            >
              特徴
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-gray-900 hover:text-amber-600 font-medium cursor-pointer"
            >
              高級腕時計
            </button>
            {brands.map((brand, index) => (
              <a
                key={index}
                href={brand.path}
                className="block w-full text-left pl-6 text-gray-700 hover:text-amber-600 font-medium cursor-pointer"
              >
                {brand.name}
              </a>
            ))}
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left text-gray-900 hover:text-amber-600 font-medium cursor-pointer"
            >
              お客様の声
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-6 py-2.5 bg-amber-600 text-white font-medium rounded-md hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
